import request from '@/utils/request'

const tradeSellContractApi = {
  trade_customs_declaration_in_list: '/trade/customs_declaration_in/',
  trade_customs_declaration_in_create: '/trade/customs_declaration_in/',
  trade_customs_declaration_in_update: '/trade/customs_declaration_in/',
  trade_customs_declaration_in_delete: '/trade/customs_declaration_in/',
  trade_customs_declaration_in_archived: '/trade/customs_declaration_in_archived/',
  trade_customs_declaration_in_attachment: '/trade/customs_declaration_in_attachment/',
  trade_customs_declaration_out_list: '/trade/customs_declaration_out/',
  trade_customs_declaration_out_create: '/trade/customs_declaration_out/',
  trade_customs_declaration_out_update: '/trade/customs_declaration_out/',
  trade_customs_declaration_out_delete: '/trade/customs_declaration_out/',
  trade_customs_declaration_out_archived: '/trade/customs_declaration_in_archived/',
  trade_customs_declaration_out_attachment: '/trade/customs_declaration_out_attachment/'
}

/**
 * 列表
 */
export function customs_declaration_in_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_in_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function customs_declaration_in_create (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_in_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function customs_declaration_in_update (parameter, customs_declaration_in_id) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_in_update + customs_declaration_in_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function customs_declaration_in_delete (customs_declaration_in_id) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_in_delete + customs_declaration_in_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function customs_declaration_in_archived (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_in_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 列表
 */
export function customs_declaration_out_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_out_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function customs_declaration_out_create (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_out_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function customs_declaration_out_update (parameter, customs_declaration_out_id) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_out_update + customs_declaration_out_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function customs_declaration_out_delete (customs_declaration_out_id) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_out_delete + customs_declaration_out_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function customs_declaration_out_archived (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_out_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 报关信息附件创建
 * @param parameter
 * @returns {AxiosPromise}
 */
export function customs_declaration_in_attachment_create (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_in_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 报关信息附件获取
 * @param parameter
 * @returns {AxiosPromise}
 */
export function customs_declaration_in_attachment_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_in_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 报关信息附件删除
 * @param parameter
 * @returns {AxiosPromise}
 */
export function customs_declaration_in_attachment_delete (attachment_id) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_in_attachment + attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 报关信息附件创建
 * @param parameter
 * @returns {AxiosPromise}
 */
export function customs_declaration_out_attachment_create (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_out_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 报关信息附件获取
 * @param parameter
 * @returns {AxiosPromise}
 */
export function customs_declaration_out_attachment_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_out_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 报关信息附件删除
 * @param parameter
 * @returns {AxiosPromise}
 */
export function customs_declaration_out_attachment_delete (attachment_id) {
  return request({
    url: tradeSellContractApi.trade_customs_declaration_out_attachment + attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
